export const scrollTabIntoView = (el)=>{
    const container = el.parentElement;
    if (!container) {
        return;
    }
    const scrollLeft = el.offsetLeft - container.clientWidth / 2 + el.clientWidth / 2;
    container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
    });
};

//# sourceMappingURL=helpers.js.map